export const timeline = [
  {
    id: 1,
    logo: "images/bcitLogo.png",
    title: "British Columbia Institute of Technology",
    details: "Certificate, Architectural CADD and Graphics Technician",
    date: "Completed June 2013",
  },
  {
    id: 2,
    logo: "images/bcitLogo.png",
    title: "British Columbia Institute of Technology",
    details: "Associate's Degree, Architectural and Building Technology",
    date: "Completed June 2015",
  },
  {
    id: 3,
    logo: "images/morrisonHershfieldLogo.png",
    title: "Morrison Hershfield",
    details: "Building Science Consultant",
    date: "August 2015 - August 2020",
    content: (
      <>
        <ul className="list-disc list-outside pl-4">
          <li>Produced building envelope detail drawings and assisted with contract administration for multiple ongoing projects</li>
          <li>Coordinated building envelope detail drawings with architectural drawings and structural requirements</li>
          <li>Collaborated with the CAD Manager to develop standardized building envelope details and create templates</li>
          <li>Worked on notable projects including TransLink, BCIT, and the Provincial Courthouse</li>
          <li>Collaborated with the Company Director to design RCABC roof detail drawings</li>
          <li>Coordinated with clients, contractors, and architects to determine site specific projects and jurisdictional requirements</li>
          <li>Developed 3D mock-ups using Revit and SketchUp to help visualize complex building envelope details and design concepts</li>
          <li>Ensured that drawings are checked, approved and filed in accordance with company quality standards</li>
          <li>Trained and managed new CAD Technicians</li>
          <li>Assisted Engineers in field reviews of rehabilitation projects to confirm that construction of the building envelope assemblies is in accordance with original design documents</li>
        </ul>
      </>
    )
  },
  {
  id: 4,
  logo: "images/avisoLogo.jpeg",
  title: "Aviso Wealth",
  details: "Quality Assurance Summer Student",
  date: "June 2021 - August 2021",
  content: (
    <>
      <ul className="list-disc list-outside pl-4">
        <li>Reviewed business and technical requirements in both an agile and waterfall environment</li>
        <li>Assisted in developing comprehensive test plans and recorded defects, leading to a reduction in critical post-release issues</li>
        <li>Developed an automation framework from scratch using Katalon Studio, increasing testing efficiency</li>
        <li>Conducted multi-browser and multi-device compatibility testing</li>
        <li>Managed bug tracking from initiation to resolution, achieving a faster resolution time and improving overall defect management</li>
        <li>Created and executed test plans, test cases, and automation scripts, achieving 95% test coverage and enhancing the overall quality of testing projects</li>
      </ul>
    </>
  )
},
  {
    id: 5,
    logo: "images/bcitLogo.png",
    title: "British Columbia Institute of Technology",
    details: "Associate's Degree, Full-Stack Web Development",
    date: "Completed April 2022",
    content: (
      <>
        <p className="pb-2">An intensive two-year program focused on building and deploying applications across the full web technology stack. Gained hands-on experience in front-end and back-end development while collaborating with designers on cross-disciplinary projects, strengthening both technical expertise and teamwork skills.</p>
        <a href="https://www.bcit.ca/programs/full-stack-web-development-diploma-full-time-7540dipma/?gclsrc=aw.ds&gad_source=1&gad_campaignid=6619783868&gbraid=0AAAAADA1Hd0YFNXvKB6Ye-sq4ZPfSMMoV&gclid=CjwKCAjw_fnFBhB0EiwAH_MfZk0WA2zS3Eey35k1s9tFrRRu3uB4S372xO1anI0clgCsa8UyJtvoTRoC8ScQAvD_BwE#courses" className="underline underline-offset-4" target="_blank" rel="noreferrer" >List of courses</a>
      </>
    )
  },
  {
    id: 6,
    logo: "images/elasticPathLogo.png",
    title: "Elastic Path",
    details: "Software Engineer",
    date: "July 2022 - October 2024",
    content: (
      <>
        <ul className="list-disc list-outside pl-4">
          <li>Implemented OpenID Connect authentication on the frontend for the accounts platform team, enabling account creation without password-based profiles and integrating with backend services on the authentication flow</li>
          <li>Collaborate with stakeholders and engineers to implement front-end Commerce Extensions - a solution that allows manufacturers and retailers to create custom APIs, that fit their operational needs</li>
          <li>Transitioned services to React Query, resulting in more efficient data fetching and a noticeable reduction in load times, enhancing overall application responsiveness</li>
          <li>Implement new features and functionalities to Elastic Path's JavaScript SDK library, including adding the Custom APIs endpoint to enhance external integration by improving flexibility and usability for developers and integrating authentication tokens for account members to enhance security, reducing security vulnerabilities</li>
          <li>Design and implement reusable components in React with future scalability in mind, allowing for easy addition of new features, reducing development time and complexity by at least 50%</li>
          <li>Work and collaborate with UX designers to enhance and improve the front-end user experience for customers</li>
          <li>Conduct monthly demos to showcase new features to stakeholders</li>
          <li>Contribute to creating and maintaining documentation by providing technical examples and insights</li>
          <li>Implemented over 20 new “actions” within Elastic Path's custom component in Integrations hub enhancing functionality and user interactions</li>
      </ul>
    </>
    )
  },
  {
    id: 7,
    logo: "images/bcitLogo.png",
    title: "British Columbia Institute of Technology",
    details: "Bridging Courses",
    date: "January 2025 - July 2025",
    content: (
      <>
        <p><strong>Summer 2025</strong></p>
        <ul className="list-disc list-inside pl-4">
        <li>
          COMP 3725 - Data Communications for CST
        </li>
        <li>
          COMP 3761 - Algorithm Analysis & Design
        </li>
        <li>
          COMP 2825 - Computer Architecture & Organization
        </li>
        </ul>
        
        <p className="mt-2"><strong>Winter 2025</strong></p>
        <ul className="list-disc list-inside pl-4">
        <li>
          COMP 2511 - Procedural Programming with C
        </li>
        <li>
          COMP 2121 - Discrete Mathematics
        </li>
        <li>
          COMP 2831 - Business Analysis & System Design
        </li>
        <li>
          MATH 1060 - Statistics for Data Analysis
        </li>
        </ul>
      </>
    )
  },
  {
    id: 8,
    logo: "images/bcitLogo.png",
    title: "British Columbia Institute of Technology",
    details: "Microcredential, Cybersecurity Analysis for Network Administrators",
    date: "September 2025 - August 2026",
    content: (
      <>
        <p className="pb-2">Completed while working full-time at Entuitive. Covered ethical hacking, network defense, SIEM and SOAR, and forensic investigation.</p>
        <ul className="list-disc list-inside pl-4">
        <li>
          XCSA 1100 - Network Programming for Security Analysts
        </li>
        <li>
          XCSA 1101 - Ethical Hacking
        </li>
        <li>
          XCSA 1102 - Network Defense Essential
        </li>
        <li>
          XCSA 1103 - Security Information and Event Management (SIEM)/Security Orchestration Automation & Response (SOAR)
        </li>
        <li>
          XCSA 1104 - Forensic Investigation
        </li>
        </ul>
      </>
    )
  },
  {
    id: 9,
    logo: "images/thirdstreamLogo.png",
    title: "thirdstream",
    details: "UX Designer (Part-time, contract)",
    date: "January 2024 - December 2026",
    content: (
      <>
        <ul className="list-disc list-outside pl-4">
          <li>Collaborate on UX planning and usability research with stakeholders to define business and user requirements</li>
          <li>Translate requirements into detailed design specifications, streamlining the design process and minimizing the need for revisions</li>
          <li>Create dynamic UI components in Figma that facilitate consistent design across projects, reducing design time and improving overall design consistency</li>
          <li>Develop flows, wireframes, mock-ups and prototypes based on the requirements and specifications</li>
      </ul>
    </>
    )
  },
  {
  id: 10,
  logo: "images/entuitiveLogo.jpeg",
  title: "Entuitive",
  details: "Building Envelope Technologist (Full-time, contract)",
  date: "November 2025 - August 2026",
  content: (
    <>
      <ul className="list-disc list-outside pl-4">
        <li>Building Envelope and Structural CAD drafting using AutoCAD and Revit</li>
        <li>Collaborate with engineers across building envelope and structural projects of varying size and complexity</li>
        <li>Develop and maintain CAD drafting and Building Envelope detail standards</li>
        <li>Use existing drawings and photographs to determine and create as-built construction details, plans and elevation drawings</li>
        <li>Communicate with people at all levels including project stakeholders and clients</li>
        <li>Manage multiple tasks, priorities and deliverables on an ongoing basis</li>
        <li>Apply knowledge of building envelope systems, such as glazing systems, air/vapor barrier systems, roofing assemblies, below grade waterproofing, and cladding assemblies to produce accurate construction details</li>
      </ul>
    </>
  )
  },
    {
    id: 11,
    logo: "images/bcitLogo.png",
    title: "British Columbia Institute of Technology",
    details: "Bachelor of Science, Applied Computer Science (Network Security Applications Development Option)",
    date: "September 2026 - Present",
    content: (
      <>
        <p className="pb-2">An intensive two-year degree program focused on designing, developing, and deploying secure network applications across Linux and Windows platforms. Gaining hands-on experience in systems-level programming, cryptography, and network security while building robust client-server applications in languages such as C, C++, and Python, culminating in a major project.</p>
        <p><strong>Winter 2027</strong></p>
        <ul className="list-disc list-inside pl-4">
        <li>
          COMP 8003 - Network Security Administration
        </li>
        <li>
          COMP 8042 - Advanced Algorithms and Data Structures Design and Analysis
        </li>
        <li>
          COMP 8082 - Project Management
        </li>
        <li>
          LIBS 7001 - Critical Reading and Writing
        </li>
        <li>
          MATH 7908 - Linear Algebra and Applications for Computing
        </li>
        </ul>

        <p className="mt-2"><strong>Fall 2026</strong></p>
        <ul className="list-disc list-inside pl-4 pb-2">
        <li>
          COMP 7003 - Introduction to Information and Network Security
        </li>
        <li>
          COMP 7005 - Computer Networks and Protocols
        </li>
        <li>
          COMP 7035 - Operating Systems
        </li>
        <li>
          COMP 7082 - Software Engineering
        </li>
        <li>
          MATH 7808 - Calculus for Computing
        </li>
        </ul>
        <a href="https://www.bcit.ca/programs/applied-computer-science-network-security-applications-development-option-bachelor-of-science-full-time-part-time-867bbsc/#courses" className="underline underline-offset-4" target="_blank" rel="noreferrer" >List of courses</a>
      </>
    )
  },
]